var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { List } from 'antd';
import ListItem from '../../ListItem';
import UserSelectionContext from '../context';
import { mapSearchContacts } from '../common';
export default function SearchContactsList(_a) {
    var searchData = _a.searchData, onclick = _a.onclick, loadMore = _a.loadMore, result = _a.result, loading = _a.loading, setTabIndex = _a.setTabIndex, searchValue = _a.searchValue, getSearchExtraPart = _a.getSearchExtraPart;
    var _b = React.useContext(UserSelectionContext), t = _b.t, frozenIds = _b.frozenIds, single = _b.single, contactsFilterFlag = _b.contactsFilterFlag, currentUser = _b.currentUser;
    var contactsData = mapSearchContacts(searchData.contacts, result, frozenIds, searchValue) || [];
    // if (loading) {
    //     return (
    //         <div
    //             style={{
    //                 width: '100%',
    //                 height: '100%',
    //                 display: 'flex',
    //                 flexDirection: 'column',
    //                 minHeight: '200px',
    //                 background: '#fff',
    //                 position: 'absolute',
    //             }}
    //         >
    //             <Loading />
    //         </div>
    //     );
    // }
    return (React.createElement("div", { className: "search-content-wrap", id: "search-content-wrap" },
        React.createElement(List, { loadMore: loadMore, dataSource: contactsData, renderItem: function (item, key) { return (React.createElement(ListItem, { data: item, onClick: function () {
                    if (onclick) {
                        onclick(__assign(__assign({}, item), { name: typeof item.name === 'string'
                                ? item.name
                                : item.displayName || '', remark: typeof item.remark === 'string'
                                ? item.remark
                                : item.realRemark || '', desc: typeof item.desc === 'string'
                                ? item.desc
                                : item.realDesc || '' }));
                    }
                }, checkable: true, single: single, disabled: item.disabled, extra: getSearchExtraPart === null || getSearchExtraPart === void 0 ? void 0 : getSearchExtraPart(item) })); } })));
}
//# sourceMappingURL=SearchContactsList.js.map